import * as yup from 'yup';

import { requiredEmailField } from '@blockpulse3/data/shared';

export const schema = yup.object({ email: requiredEmailField }).required();
